<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ConsigneeShipperAndNotifyAddress')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
  >
    <el-form label-width="120px" label-position="left" style="width: 100%;margin-bottom: 5px">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
            <cargo-company-select
              :method-params="{customer:true}"
              :default-value="filter.partnerId||''"
              @change="p=>{filter.partnerId=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
            <cargo-advance-select
              :select-type="(this.filter.lob === 'SE' || this.filter.lob === 'SI') ? selectTypeNames.basic_data_Seaport : selectTypeNames.basic_data_Airport"
              filterable
              :default-value="filter.pod"
              @parentCallBack="p=>filter.pod=p.value"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('SeaExport.DestinationAgent')">
            <cargo-advance-select
              no="destinationAgent"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
              :default-value="filter.destinationAgent"
              filterable
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              tag-name="englishName"
              :callback-params="{key:'destinationAgent'}"
              callback-method-type="value"
              @parentCallBack="p=>filter.destinationAgent=p.value"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ShipperId')">
            <el-input v-model="filter.shipperCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeId')">
            <el-input v-model="filter.consigneeCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_NotifyId')">
            <el-input v-model="filter.notifyCode" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('SeaExport.consignorName')">
            <el-input v-model="filter.shipperEnterpriseName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('SeaExport.consigneeName')">
            <el-input v-model="filter.consigneeEnterpriseName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('SeaExport.notifyingName')">
            <el-input v-model="filter.notifyEnterpriseName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col style="text-align: left">
          <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <cargo-ag-grid
      config-module="12011501"
      :wrap-text="true"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
    />
    <span slot="footer">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <div>
          <el-button v-permission="['button_JobBillAddress_addBillAddress']" no="addMailingAddress" type="primary" @click="addMailingAddress">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button v-permission="['button_JobBillAddress_editBillAddress']" no="editMailingAddress" type="primary" @click="editMailingAddress">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_JobBillAddress_deleteBillAddress']" no="deleteMailingAddress" type="danger" @click="deleteMailingAddress">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
        <div>
          <el-button
            type="primary"
            @click="choose(['shipper'])"
          >{{ isSeaHouseChannel ? $t('SeaExport.CopyManifestShipper') : $t('SeaExport.CopyShipper') }}</el-button>
          <el-button
            type="primary"
            @click="choose(['consignee'])"
          >{{ isSeaHouseChannel ? $t('SeaExport.CopyManifestConsignee') : $t('SeaExport.CopyConsignee') }}</el-button>
          <el-button
            type="primary"
            @click="choose(['notify'])"
          >{{ isSeaHouseChannel ? $t('SeaExport.CopyManifestNotify') : $t('SeaExport.CopyNotify') }}</el-button>
          <el-button
            type="primary"
            @click="choose(['shipper','consignee','notify'])"
          >{{ $t('CargoMsg.Cargo_Select') }}</el-button>
          <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </div>
    </span>

    <mailing-address-maintain-dialog
      :visible.sync="mailingAddressMaintainDialog.visible"
      :dialog-title="mailingAddressMaintainDialog.title"
      :form="mailingAddressMaintainDialog.form"
      :type="mailingAddressMaintainDialog.type"
      :job="job"
      @callback="toQuery"
    />
  </el-dialog>
</template>

<script>

import mailingAddressMaintainDialog from '@/components/Cargo/Job/mailingAddressMaintainDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { batchDelMailingAddress, findMailingAddressByUuid, queryAddressList } from '@/api/partner/mailingAddress'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'CustomerShippingInformationCopyDialog',
  components: { mailingAddressMaintainDialog, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    isSeaHouseChannel: { type: Boolean, required: true },
    job: { type: Object, default: null }
  },
  data() {
    return {
      mailingAddressMaintainDialog: {
        visible: false,
        title: '',
        type: '',
        form: {}
      },
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      oldShipperCode: '',
      oldConsigneeCode: '',
      oldNotifyCode: '',
      filter: {
        lob: 'SE',
        partnerId: '',
        pod: '',
        shipperCode: '',
        consigneeCode: '',
        notifyCode: '',
        officeId: '',
        mbl: false,
        isPortFilter: true,
        shipperEnterpriseName: '',
        consigneeEnterpriseName: '',
        destinationAgent: '',
        notifyEnterpriseName: ''
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 150,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.selectItemClickHandler
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperCode'),
          field: 'shipperCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.ManifestFormatShipper'),
          hide: true,
          field: 'shipperInfoFormat',
          width: 200,
          cellRenderer: (params) => CargoDocUtil.shipperAddressFormat(params.data, 'shipper')
        }, {
          headerName: this.$t('baseInfo.mailingAddress.shipperInfo'),
          field: 'shipperInfo',
          width: 200,
          cellRenderer: (params) => this.multipleDataRellRenderer(params.data, 'shipperLine')
        }, {
          headerName: this.$t('baseInfo.mailingAddress.consigneeCode'),
          field: 'consigneeCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.TheManifestFormatConsignee'),
          hide: true,
          field: 'consigneeInfoFormat',
          width: 200,
          cellRenderer: (params) => CargoDocUtil.consigneeAddressFormat(params.data, 'consignee')
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.pod1'),
          field: 'pod',
          cellRenderer: (params) => {
            if (params.data) {
              const englishName = params.data['podEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data) {
              const englishName = params.data['podEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('baseInfo.mailingAddress.consigneeInfo'),
          field: 'consigneeInfo',
          width: 200,
          cellRenderer: (params) => this.multipleDataRellRenderer(params.data, 'consigneeLine')
        }, {
          headerName: this.$t('baseInfo.mailingAddress.notifyCode'),
          field: 'notifyCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.mailingAddress.ManifestFormatNotifier'),
          hide: true,
          field: 'notifyInfoFormat',
          width: 200,
          cellRenderer: (params) => CargoDocUtil.notifyAddressFormat(params.data, 'notify')
        }, {
          headerName: this.$t('baseInfo.mailingAddress.notifyInfo'),
          field: 'notifyInfo',
          width: 200
        }, {
          headerName: this.$t('SeaExport.consignorName'),
          field: 'shipperEnterpriseName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.consigneeName'),
          field: 'consigneeEnterpriseName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.notifyingName'),
          field: 'notifyEnterpriseName',
          width: 200
        }
      ],
      selectItem: null,
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
      this.selectItem = null
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
      this.toQuery()
    }
  },
  methods: {
    addMailingAddress() {
      this.mailingAddressMaintainDialog.form = {}
      this.mailingAddressMaintainDialog.title = this.$t('baseInfo.mailingAddress.addMailingAddress')
      this.mailingAddressMaintainDialog.type = 'add'
      this.mailingAddressMaintainDialog.visible = true
    },
    editMailingAddress() {
      const self = this
      if (!self.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const uuid = this.selectItem.uuid
      findMailingAddressByUuid(uuid).then(result => {
        self.mailingAddressMaintainDialog.form = { ...result.data }
        self.mailingAddressMaintainDialog.type = 'edit'
        self.mailingAddressMaintainDialog.title = self.$t('baseInfo.mailingAddress.editMailingAddress')
        self.mailingAddressMaintainDialog.visible = true
      })
    },
    deleteMailingAddress() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfirmation'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const loading = getLoading4Cxt(this)
          batchDelMailingAddress(ids).then(res => {
            self.toQuery()
            this.$message.success(this.$t('common.tips.deleteSuccess'))
          }).finally(() => {
            loading.close()
          })
        }).catch(() => {
          this.$message.info(this.$t('common.tips.cancelDelete'))
        })
      })
    },
    init() {
      if (!this.innerVisible) {
        return
      }
      this.filter.partnerId = ''
      this.filter.pod = ''
      this.filter.shipperCode = ''
      this.filter.shipperCode = ''
      this.filter.consigneeCode = ''
      this.filter.notifyCode = ''
      this.filter.officeId = ''
      const job = this.job
      if (this.job) {
        this.filter.lob = job.lob
        let customerId = 0
        let destPort = ''
        if (job.lob === 'SE' || job.lob === 'SI') {
          if (this.filter.mbl && !!job.mblOnly) {
            customerId = job.customerId
            destPort = job.destinationPortCode
          } else if (this.filter.mbl) {
            customerId = job.destinationAgent
            destPort = job.destinationPortCode
          } else {
            customerId = job.customerId
            destPort = job.destinationPortCode
          }
        }
        this.filter.destinationAgent = job.destinationAgent
        this.filter.partnerId = customerId
        this.filter.pod = destPort || job.dischargingPortCode
      }
    },
    selectItemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectItem = event.data
    },
    reset() {
      if (!this.filter) return
      for (const key in this.filter) {
        this.filter[key] = ''
      }
    },
    toQuery() {
      const loading = getLoading4Cxt(this)
      this.filter.officeId = this.$store.getters.currentOfficeId
      queryAddressList(this.filter).then(res => {
        this.rowData = res.data.list
      }).finally(() => {
        this.selectItem = null
        this.gridOptions.api.clearFocusedCell()
        loading.close()
      })
    },
    multipleDataRellRenderer(data, field) {
      const array = []
      for (let i = 1; i <= 7; i++) {
        if (data[field + i]) {
          array.push(data[field + i])
        }
      }
      return array.join('<br/>')
    },
    choose(fieldKeys) {
      if (!this.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('selected', this.selectItem, fieldKeys)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
